const API_AUTH_USERNAME = "dgpara-api@2025";
const API_AUTH_PASSWORD = "er45455+}ybTET34g";
// const API_BASE_URL = "https://api.Dgpara Vendor.in/";
const API_BASE_URL = "https://dgpara-api.kamiras.com/";
export { API_AUTH_USERNAME, API_AUTH_PASSWORD, API_BASE_URL };